// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --logoHeightExtraSmall: 1.25rem;
  --logoHeightSmall: 1.625rem;
  --logoHeightLegacy: 2.25rem;
  --logoHeight: 2rem;
}

:host {
  display: flex;
}

.ftr-logo {
  display: inline-block;
}

.ftr-logo--small {
    height: 1.625rem;
  }

.ftr-logo--legacy {
    height: 2.25rem;
  }

.ftr-logo--default {
    height: 2rem;
  }

.ftr-logo--extra-small {
    height: 1.25rem;
  }

.ftr-logo__logo {
    height: 100%;
  }

.ftr-logo--full-width {
    width: 100%;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
